import './ClOfferSnippet.css';

import React from 'react';

import classname from '@search/classname/src';

import { ClGalleryEmpty } from '../../gallery/ClGalleryEmpty';

const cn = classname.bind(null, 'ClOfferSnippet');

export function ClOfferSnippet({
    gallery = <ClGalleryEmpty />,
    children,
    border,
    highlight,
    top,
    onClick,
    onMouseEnter,
    onMouseLeave,
    dataTest,
    containerRef,
    id
}: {
    onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
    onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
    id?: string;
    containerRef?: React.Ref<HTMLDivElement>;
    dataTest?: string;
    children: React.ReactNode;
    gallery?: React.ReactNode;
    border?: boolean;
    highlight?: boolean;
    top?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}) {
    return (
        <div
            id={id}
            ref={containerRef}
            className={cn(null, {
                noBorder: ! border,
                highlight: highlight && border,
                top,
                noClickable: ! onMouseEnter
            })}
            data-test={dataTest}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className={cn('gallery')}>
                {gallery}
            </div>
            {children}
        </div>
    );
}
